import { render } from "./SortButtons.vue?vue&type=template&id=46fbe370&scoped=true&ts=true"
import script from "./SortButtons.vue?vue&type=script&lang=ts"
export * from "./SortButtons.vue?vue&type=script&lang=ts"

import "./SortButtons.vue?vue&type=style&index=0&id=46fbe370&lang=scss&scoped=true"

import exportComponent from "C:\\www\\Marta\\redadom.pl\\apartment-table\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46fbe370"]])

export default __exports__